import * as React from "react";
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import ReactLeafletKml from "react-leaflet-kml";
import { ZONE_COUVERTURE } from "../../Utils/constant";
import { find } from "../../services/service";

function Kml({
  userLocation,
  setUserLocation,
  zoneCouverte,
  setLatitude,
  setLongitude,
  mapCenter,
  mapZoom,
  onMapCenterChange,
  onMapZoomChange,
}) {
  const [kml, setKml] = React.useState(null);

  const LocationFinderDummy = () => {
    useMapEvents({
      click(e) {
        const lat = e?.latlng?.lat;
        const lng = e?.latlng?.lng;

        setUserLocation([lat, lng]);
        setLatitude(lat);
        setLongitude(lng);

        if (onMapCenterChange) {
          onMapCenterChange([lat, lng]);
        }
      },
    });
    return userLocation ? <Marker position={userLocation}></Marker> : null;
  };

  React.useEffect(() => {
    if (zoneCouverte) {
      find(`${ZONE_COUVERTURE}/${zoneCouverte.id}`).then((kmlText) => {
        const parser = new DOMParser();
        const kml = parser.parseFromString(kmlText.data, "text/xml");
        setKml(kml);
      });
    }
  }, [zoneCouverte]);

  const handleMarkerClick = (e) => {
    if (userLocation !== undefined) {
      setUserLocation([e?.latlng?.lat, e?.latlng?.lng]);
      setLatitude(e?.latlng?.lat);
      setLongitude(e?.latlng?.lng);
    }
  };

  const getInitialCenter = () => {
    if (mapCenter) return mapCenter;
    if (userLocation) return userLocation;
    return [5.342, -4.024]; // Centre d'Abidjan par défaut
  };

  const getInitialZoom = () => {
    if (mapZoom) return mapZoom;
    return userLocation ? 13 : 14;
  };

  // Déterminer les bounds si nécessaire
  const getBounds = () => {
    if (mapCenter || userLocation) return [5.316667, -4.033333];
    return [userLocation, [5.3677654, -3.9596936]];
  };

  return (
    <div>
      <MapContainer
        key={`${getInitialCenter()}-${getInitialZoom()}`} // Force re-render si nécessaire
        className="h-[200px] lg:h-[400px] lg:w-full rounded-lg"
        style={{ zIndex: 0 }}
        center={getInitialCenter()}
        zoom={getInitialZoom()}
        bounds={getBounds()}
        boundsOptions={{ padding: [20, 20] }}
      >
        <LocationFinderDummy />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {kml && (
          <ReactLeafletKml
            eventHandlers={{ click: handleMarkerClick }}
            kml={kml}
          />
        )}
      </MapContainer>
    </div>
  );
}

export default Kml;
